import woodtypes from "@/common/woodtypes";
import {ADD_ALL_TO_WATCHLIST, ADD_TO_WATCHLIST} from "@/store/actions.type";
import {CURRENCIES} from "@/common/constants";

/**
 * Mixin with log utility methods
 */
export default {
	computed: {
		priceUnit() {
			return this.selectedWatchlist ? `${CURRENCIES[this.selectedWatchlist.currency]}${this.$t('unit.perSqm')}` : '';
		}
	},
	methods: {
		getConcreteItem(item) {
			return item !== null ? item.spliced || item.timber || item.virtual || item.veneer || item : null;
		},
		setConcreteItem(item, concreteItem) {
			item.spliced = item.spliced ? concreteItem : item.spliced;
			item.timber = item.timber ? concreteItem : item.timber;
			item.virtual = item.virtual ? concreteItem : item.virtual;
			item.veneer = item.veneer ? concreteItem : item.veneer;
		},
		isItemVirtual(item) {
			return item.itemType === woodtypes.VIRTUAL;
		},
		addObjectToWatchlist(object, watchlist) {
			this.$store.dispatch(ADD_TO_WATCHLIST, {
				objects: [this.getConcreteItem(object)],
				watchlist: watchlist.uid
			});
		},
		/**
		 * Adds all items from source to target watchlist
		 * @param target
		 * @param source
		 */
		addWatchlistItemsToWatchlist(target, source) {
			this.$store.dispatch(ADD_ALL_TO_WATCHLIST, {
				target: target.uid,
				source: source.uid
			});
		}
	}
}